import React from "react"
import { motion } from "framer-motion"

interface MapProps {
  className?: string
}

const CHURCH_MAPS_URL =
  "https://www.google.com/maps/search/?api=1&query=Iglesia+de+San+Miguel+Arcángel+Morón+de+la+Frontera"
const HACIENDA_MAPS_URL =
  "https://www.google.com/maps/search/?api=1&query=Hacienda+Saltillo-Lasso+Puente+Genil+Córdoba"

const Map: React.FC<MapProps> = ({ className = "" }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
      className={`${className}`}
    >
      <div className="bg-cream-50/90 backdrop-blur-sm rounded-3xl shadow-lg border border-sand-200/50 p-6">
        <div className="mb-6">
          <h3 className="font-avenir text-2xl font-bold text-terracotta-800 mb-2 flex items-center justify-center">
            <span className="mr-2">📍</span>
            Ubicación
          </h3>
        </div>

        <div className="space-y-6">
          <div className="flex items-start space-x-4">
            <div className="flex-shrink-0 w-12 h-12 bg-olive-100 rounded-full flex items-center justify-center">
              <span className="text-terracotta-600 font-bold">⛪</span>
            </div>
            <div>
              <h4 className="font-avenir font-semibold text-gray-800">
                Iglesia de San Miguel Arcángel
              </h4>
              <p className="font-avenir text-sm text-gray-500 mt-1">
                Plaza del Cardenal Spínola, s/n
                <br />
                41530 Morón de la Frontera (Sevilla)
              </p>
              <a
                href={CHURCH_MAPS_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="font-avenir text-sm text-olive-600 hover:text-olive-700 underline mt-2 inline-block"
              >
                📍 Cómo llegar en Google Maps
              </a>
            </div>
          </div>

          <div className="flex items-start space-x-4">
            <div className="flex-shrink-0 w-12 h-12 bg-olive-100 rounded-full flex items-center justify-center">
              <span className="text-beige-600 font-bold">🏡</span>
            </div>
            <div>
              <h4 className="font-avenir font-semibold text-gray-800">
                Hacienda Saltillo-Lasso
              </h4>
              <p className="font-avenir text-sm text-gray-500 mt-1">
                Autovia Sevilla-Madrid, Salida 523
                <br />
                41012 Sevilla
              </p>
              <a
                href={HACIENDA_MAPS_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="font-avenir text-sm text-olive-600 hover:text-olive-700 underline mt-2 inline-block"
              >
                📍 Cómo llegar en Google Maps
              </a>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  )
}

export default Map
